import React from 'react';
import { Outlet } from 'react-router-dom';

export default function EnhancedLayout() {
  return (
    <div className="container mx-auto px-4 py-4">
      <Outlet />
    </div>
  );
}
